<template>
  <ion-card color="light" class="border-default no-shadow spacing-xs filter-card ion-no-margin">
    <div class="b-grey ion-padding-bottom">
      <h1 class="font-md bold-medium">{{ t('invoices.to') }}</h1>
      <div class="d-flex flex-column gap-xs mt-sm">
        <div>
          <p class="font-xs mt-sm">{{ invoiceSelected?.CentreBillingInfo.brandName }}</p>
          <p class="font-xs mt-sm">{{ invoiceSelected?.CentreBillingInfo.documentId }}</p>
          <p class="font-xs mt-sm">{{ invoiceSelected?.CentreBillingInfo.email }}</p>
        </div>
      </div>
    </div>

    <div class="mt-sm">
      <h1 class="font-md bold-medium">{{ t('invoices.from') }}</h1>
      <div class="d-flex flex-column gap-xs mt-sm">
        <div>
          <p class="font-xs mt-sm">{{ invoiceSelected?.TenantBillingInfo.name }}</p>
          <p class="font-xs mt-sm">{{ invoiceSelected?.TenantBillingInfo.documentId }}</p>
          <p class="font-xs mt-sm">{{ invoiceSelected?.TenantBillingInfo.Location.fullAddress }}</p>
        </div>
      </div>
    </div>
  </ion-card>
</template>

<script setup lang="ts">
  import { useBillingStore } from '@/stores/billing-store';
  import { IonCard } from '@ionic/vue';
  import { storeToRefs } from 'pinia';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const { invoiceSelected } = storeToRefs(useBillingStore());
</script>
